import React from 'react'
import PropTypes from 'prop-types';
import style from './style.css'

export default class NoNetworksView extends React.Component {

  render() {
    return ( 
      <div className={style.noItems}>
        <div className="line1">You have no custom Networks </div>
      </div>
    );
  }
}
